import { render, staticRenderFns } from "./footer-subscribe.vue?vue&type=template&id=44180a66&scoped=true"
import script from "./footer-subscribe.vue?vue&type=script&lang=js"
export * from "./footer-subscribe.vue?vue&type=script&lang=js"
import style0 from "./footer-subscribe.vue?vue&type=style&index=0&id=44180a66&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44180a66",
  null
  
)

export default component.exports